<section class="content">
  <div class="card" style="padding: 24px;">
    <div class="container-fluid">
      <div class="row">
        <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
          {{title}}
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <mat-label>Select Counter</mat-label>
          <mat-select [(ngModel)]="selected_counter_id" class="main-border-class">
            <mat-option *ngFor="let counter of counter_list" [value]="counter.id">{{counter['name']}}</mat-option>
          </mat-select>
        </div>
        <div class="col-3">
          <mat-label>Select Date</mat-label>
          <input type="date" [(ngModel)]="selected_date" class="main-border-class" />
        </div>
        <div class="col-3">
          <mat-label>Select Type of user</mat-label>
          <mat-select [(ngModel)]="selected_report_option" class="main-border-class">
            <mat-option *ngFor="let booth_customer of booth_or_customer_json" [value]="booth_customer['name']">
              {{booth_customer['display_name']}}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-2">
          <button (click)="getClicked()"
            style="font-size: 27px;margin-top: 14%;border-radius: 5px;background: blanchedalmond;"
            [disabled]="checkDisable()">Get</button>
        </div>
      </div>
    </div>
    <div *ngIf="!is_data_available">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
      </mat-progress-spinner>
    </div>
    <div *ngIf="is_data_available">
      <div *ngIf="selected_report_option == 'booth'">
        <div class="table-responsive" *ngIf="counte_agent_order_details!=null">
          <div class="row">
            <div class="col-6"></div>
            <div class="col-6">
              <div class="row">
                <div class="col-4">
                  <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="50"
                    *ngIf="!is_document_available">
                  </mat-progress-spinner>
                </div>
                <div class="col-4">
                  <button mat-button class="button-class" (click)="downloadReportCliked()"><i class="material-icons">
                      picture_as_pdf
                    </i> Download report</button>
                </div>
                <div class="col-4">
                  <button mat-button class="button-class"><i class="material-icons">
                      get_app
                    </i> Download Excel</button>
                </div>
              </div>
            </div>
          </div>
          <!-- <button (click)="printCalled()"></button> -->
          <br>
          <table class="table table-bordered table-hover" id="printTable">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Time@</th>
                <th>Booth#</th>
                <th>Agent</th>
                <th>Zone</th>
                <th>Total</th>
                <th *ngFor="let product of counte_agent_order_details['product_list']">{{product['short_name']}}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let business of booth_code_list; let business_index=index">
                <td>{{business_index + 1}}</td>
                <td style="text-align: right;">{{counte_agent_order_details['booth_sale'][business]['time']}}</td>
                <td>{{business}}</td>
                <td>{{counte_agent_order_details['booth_sale'][business]['agent_name']}}</td>
                <td>{{counte_agent_order_details['booth_sale'][business]['zone']}}</td>
                <td style="text-align: right;">
                  {{counte_agent_order_details['booth_sale'][business]['product_total_cost'] | currency : 'INR'}}</td>
                <td *ngFor="let product of counte_agent_order_details['product_list']">
                  <span *ngIf="counte_agent_order_details['booth_sale'][business]['ns'].hasOwnProperty(product['id'])">
                    {{counte_agent_order_details['booth_sale'][business]['ns'][product['id']]['count']}}
                  </span>
                  <span *ngIf="counte_agent_order_details['booth_sale'][business]['ws'].hasOwnProperty(product['id'])">
                    {{counte_agent_order_details['booth_sale'][business]['ws'][product['id']]['count']}}
                  </span>
                </td>
              </tr>
              <!-- <tr>
              <td colspan="3" style="text-align: right;">Total Packet</td>
              <td *ngFor="let product of counte_agent_order_details['product_list']">
                0
              </td>
              <td style="text-align: right;"></td>
            </tr>
            <tr>
              <td style="text-align: right;" id="grand_total">
                Grand Total
              </td>
              <td style="text-align: right;">{{counte_agent_order_details['grand_total'] | currency : 'INR'}}</td>
            </tr> -->
            </tbody>
          </table>
          <div class="row">
            <div class="col" style="text-align: center;font-size: 25px;font-weight: bold;">
              The total money collected at counter {{counte_agent_order_details['counter_details']['counter_name']}} on
              {{selected_date | date}} is {{counte_agent_order_details['grand_total'] | currency : 'INR'}}.
            </div>
          </div>
          <div class="row">
            <div class="col">
              <hr style="background: lightgray;">
            </div>
          </div>
          <!-- <div class="row">
          <div class="col-6">
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Product</th>
                  <th>Total Packet</th>
                  <th>Total litre</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let product of counte_agent_order_details['product_list']; let product_index=index">
                  <td>{{product_index + 1}}</td>
                  <td>{{product['short_name']}}</td>
                  <td style="text-align: right;">{{counte_agent_order_details['product_count'][product['id']]}}</td>
                  <td style="text-align: right;">
                    {{counte_agent_order_details['product_wise_liter'][product['id']] | number : '1.1-4'}}</td>
                </tr>
                <tr>
                  <td colspan="2" style="text-align: right;">Total</td>
                  <td style="text-align: right;">{{counte_agent_order_details['total_packet']}} Pkts</td>
                  <td style="text-align: right;">{{counte_agent_order_details['total_liter'] | number : '1.1-4'}} Liters
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> -->
        </div>
      </div>

      <div *ngIf="selected_report_option == 'customer'">
        <div class="table-responsive" *ngIf="counter_customer_order_details!=null">
          <div class="row">
            <div class="col-6"></div>
            <div class="col-6">
              <div class="row">
                <div class="col-4">
                  <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="50"
                    *ngIf="!is_document_available">
                  </mat-progress-spinner>
                </div>
                <div class="col-4">
                  <button mat-button class="button-class" (click)="downloadReportCliked()"><i class="material-icons">
                      picture_as_pdf
                    </i> Download report</button>
                </div>
                <div class="col-4">
                  <button mat-button class="button-class"><i class="material-icons">
                      get_app
                    </i> Download Excel</button>
                </div>
              </div>
            </div>
          </div>
          <br>
          <table class="table table-bordered table-hover">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Code</th>
                <th>Customer</th>
                <th>B.Code</th>
                <th>Month</th>
                <th *ngFor="let product of counter_customer_order_details['product_list']">{{product['short_name']}}
                </th>
                <th>Total Per day</th>
                <th>Total per Month</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let business of counter_customer_order_details['agent_details']; let business_index=index">
                <td>{{business_index +1 }}</td>
                <td>{{ business['customer_code'] }}</td>
                <td>{{business['customer_name']}}</td>
                <td>{{business['business_code']}}</td>
                <td>{{business['for_month']}}</td>
                <td *ngFor="let product of counter_customer_order_details['product_list']">
                  <span
                    *ngIf="counter_customer_order_details['icustomer_sale_details'][business['for_date']][business['icustomer_id']].hasOwnProperty(product['id'])">
                    {{counter_customer_order_details['icustomer_sale_details'][business['for_date']][business['icustomer_id']][product['id']]['icustomer_sale_count']}}
                  </span>
                  <span
                    *ngIf="!counter_customer_order_details['icustomer_sale_details'][business['for_date']][business['icustomer_id']].hasOwnProperty(product['id'])">
                    - </span>
                </td>
                <td>
                  {{counter_customer_order_details['icustomer_sale_details'][business['for_date']][business['icustomer_id']]['product_total_cost']  | currency : 'INR'}}
                </td>
                <td>
                  {{counter_customer_order_details['icustomer_sale_details'][business['for_date']][business['icustomer_id']]['product_cost_month']  | currency : 'INR'}}
                </td>
              </tr>
              <tr>
                <td></td>
                <td colspan="4" style="text-align: right;">Total Packets</td>
                <td *ngFor="let product of counter_customer_order_details['product_list']">
                  {{counter_customer_order_details['product_total_count'][product['id']]}}
                </td>
                <td colspan="2"></td>
              </tr>
              <tr>
                <td style="text-align: right;" id="grand_total">Grand Total</td>
                <td>{{counter_customer_order_details['grand_total_month']  | currency : 'INR'}}</td>
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="col" style="text-align: center;font-size: 25px;font-weight: bold;">
              The total money collected at counter {{counter_customer_order_details['counter_details']['counter_name']}}
              on
              {{selected_date | date}} is {{counter_customer_order_details['grand_total_month'] | currency : 'INR'}}.
            </div>
          </div>
          <div class="row">
            <div class="col">
              <hr style="background: lightgray;">
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <table class="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Product</th>
                    <th>Total Packet</th>
                    <th>Total litre</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let product of counter_customer_order_details['product_list']; let product_index=index">
                    <td>{{product_index + 1}}</td>
                    <td>{{product['short_name']}}</td>
                    <td style="text-align: right;">
                      {{counter_customer_order_details['product_total_count'][product['id']]}}</td>
                    <td style="text-align: right;">
                      {{counter_customer_order_details['product_wise_liter'][product['id']] | number : '1.1-4'}}</td>
                  </tr>
                  <tr>
                    <td colspan="2" style="text-align: right;">Total</td>
                    <td style="text-align: right;">{{counter_customer_order_details['total_packet']}} Pkts</td>
                    <td style="text-align: right;">{{counter_customer_order_details['total_liter'] | number : '1.1-4'}}
                      Liters
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
